<template>
  <div style="width: 100%;height: 100%;background-color: #e2e2e2;overflow: auto" class="program">
    <!--建筑空间-->
    <div style="width: 100%;height: 25%;background-color: white;overflow: hidden;background-size: 100% 100%">
      <el-row :gutter="10" type="flex"  style="min-height: 80%;top: 10%">
        <el-col :span="5">
          <div style="text-align: center;width: 100%;height: 100%;" >
            <div><span style="font-size: 1.5vh;color: #060606;font-weight: 800">建筑空间场景应用</span></div>
            <div style="margin-top: 5px;padding-left: 20px;padding-right: 20px;text-align: left">
              <span style="font-size: 1.2vh;color: #6f6f6f;">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;建筑空间智能化长期被忽略，建筑空间是空调、配电、照明、门禁等系统的最终服务对象，
              也是能耗最终消耗的对象，建筑空间智能化才是建筑智能化、建筑节能的最终手段，
              也是多年来智能建筑不智能的根源所在。
              </span>
            </div>
            <div style="position: absolute;top: 87%;left: 2%;color: #3e077d;cursor: pointer" @click="sceneDetails('architecture')"><span>更多场景-></span></div>
            <div style="position: absolute;top: 87%;left: 14%;color: #3e077d;cursor: pointer" @click="creationScence"><span>创建场景-></span></div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer" @click="programDetails">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/icon/1.jpg');background-size: 100% 100%;cursor: pointer"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px;cursor: pointer">
              <div><span style="color: black;font-size: 1vh;font-weight: 800;cursor: pointer">办公室场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh;cursor: pointer">适用于面积较小的独立办公区域，实现物联网化智能管理</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/2.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">会议室场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">针对会议室空调、照明、空气质量、能耗及相关会议设备进...</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/4.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">开放式办公空间场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">开放空间空调、照明、配电、能耗、分区智能控制管理</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/5.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">通道空间场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">走廊、电梯厅等公共空间空调、照明控制管理</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/1-5.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">酒店客房场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">酒店客房空调、照明、门禁、配电、能耗、客控物联网化管理</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/1-6.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">公寓场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">公寓环境控制，水电气、计量控制、照明控制，安全管理...</span></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--机电设备-->
    <div style="width: 100%;height: 25%;background-color: white;margin-top: 2%;overflow: hidden;background-size: 100% 100%">
      <el-row :gutter="10" type="flex"  style="min-height: 80%;top: 10%">
        <el-col :span="5">
          <div style="text-align: center;width: 100%;height: 100%;" >
            <div><span style="font-size: 1.5vh;color: #060606;font-weight: 800">机电设备场景应用</span></div>
            <div style="margin-top: 5px;text-align: left;padding-left: 20px;padding-right: 20px"><span style="font-size: 1.2vh;color: #7f7f7f;">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;建筑常用机电设备包括各种形式空调机组、新风机组、送排风机、给排水设备、电梯等，
              通过物联网组件对这些设备实现物联网化管理，使提升建筑管理水平的有效手段。
               </span>
            </div>
            <div style="position: absolute;top: 87%;left: 2%;color: #3e077d;cursor: pointer" @click="sceneDetails('electromechanical')"><span>更多场景-></span></div>
            <div style="position: absolute;top: 87%;left: 14%;color: #3e077d;cursor: pointer" @click="sceneDetails('architecture')"><span>创建场景-></span></div>

          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/2-1.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">空调机组控制场景A</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">两管制、新、送、回风、单风机直接启动，空调机组控制</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/2-4.png');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">空调机组控制场景B</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">四管制、新、送、回风、双风机直接启动，空调机组控制</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/2-3.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">大空间空调机组控制这场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">针对会展中心、机场、客运站、大型商场等大空间空调...</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/2-2.png');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">新风机组控制场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">两管制，单风机直接启动式新风机组控制管理</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/2-5.png');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">新风机组控制场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">四管制、单风机、变频新风机组控制管理</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/2-1.png');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">热回收式新风机组控制场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">两管制、双风机、全热换热式新风机组控制管理</span></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--冷冻站场景-->
    <div style="width: 100%;height: 25%;background-color: white;margin-top: 2%;overflow: hidden;background-size: 100% 100%">
      <el-row :gutter="10" type="flex"  style="min-height: 80%;top: 10%">
        <el-col :span="5">
          <div style="text-align: center;width: 100%;height: 100%;" >
            <div><span style="font-size: 1.5vh;color: #060606;font-weight: 800">冷冻站场景应用</span></div>
            <div style="margin-top: 5px;text-align: left;padding-left: 20px;padding-right: 20px;"><span style="font-size: 1.2vh;color: #777574;">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;冷冻站为大型公建的主要空调设施，
             为确保足够的可靠性，
              通过控制总线方式实现各单体设备间的运行逻辑关系，并通过边缘计算设备将整个站房设施接入云环境。
              冷水机组和循环泵、冷却塔的变频拖动设备通过通讯协议方式接入边缘计算设备。</span></div>
            <div style="position: absolute;top: 87%;left: 2%;color: #3e077d;cursor: pointer" @click="sceneDetails('freezing')"><span>更多场景-></span></div>
            <div style="position: absolute;top: 87%;left: 14%;color: #3e077d;cursor: pointer" @click="sceneDetails('architecture')"><span>创建场景-></span></div>

          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/开立螺杆机组.png');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">开立螺杆机组物联网控制网关</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">开立系列螺杆机组物联网接入设备，支持MQTT协议及本地...</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/开立离心机组.png');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">开立离心机组物联网控制网关</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">开立系列离心机组物联网接入设备，支持MQTT协议及本地...</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/开立热泵机组.png');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">开立热泵机组物联网控制网关</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">开立系列热泵机组物联网接入设备，支持MQTT协议及本地...</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer" @click="yueke = true">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/约克螺杆机组.png');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">约克螺杆机组物联网控制网关</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">约克系列螺杆机组物联网接入设备，支持MQTT协议及本地...</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/约克离心机组.png');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">约克离心机组物联网控制网关</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">约克系列离心机组物联网接入设备，支持MQTT协议及本地...</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/约克热泵机组.png');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">约克模块机组物联网控制网关</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">约克系列模块机组物联网接入设备，支持MQTT协议及本地...</span></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
     <!--数据集成-->
    <div style="width: 100%;height: 25%;background-color: white;margin-top: 2%;overflow: hidden;background-size: 100% 100%">
      <el-row :gutter="10" type="flex"  style="min-height: 80%;top: 10%">
        <el-col :span="5">
          <div style="text-align: center;width: 100%;height: 100%;" >
            <div><span style="font-size: 1.5vh;color: #060606;font-weight: 800">数据集成应用</span></div>
            <div style="margin-top: 5px;text-align: left;padding-left: 20px;padding-right: 20px"><span style="font-size: 1.2vh;color: #7f7f7f;">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数据中心环境监控、精密空调、除湿设备监控、配电系统、UPS、蓄电池间监控、微型数据中心物联网化管理
              、建筑配电系统监控管理及能耗管理等领域的支持2次开发可配置物联网场景产品。
               </span>
            </div>
            <div style="position: absolute;top: 87%;left: 2%;color: #3e077d;cursor: pointer" @click="sceneDetails('dataint')"><span>更多场景-></span></div>
            <div style="position: absolute;top: 87%;left: 14%;color: #3e077d;cursor: pointer" @click="creationScence"><span>创建场景-></span></div>

          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/4-1.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">数据中心机房环境监控场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">机房环境温湿度监测、照明控制、门禁管理、漏水监测...</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/4-2.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">精密空调除湿设备监控场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">数据中心精密空调设备、除湿设备、物联网化管理...</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/4-3.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">数据中心配电监控场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">数据中心变配电设施、电力仪表及其他智能仪表物联网化接入</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/4-4.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">UPS监控场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">数据中心UPS物联网化接入，支持基于RS485的标准及非标协议</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/4-5.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">电池间监控场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">数据中心电池间物联网化接入，支持基于RS485的标准及非标协议</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/4-6.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">IDU监控场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">微型数据中心物联网化管理，用于实现机柜内环境及电力...</span></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
     <!--其他行业-->
    <div style="width: 100%;height: 25%;background-color: white;margin-top: 2%;overflow: hidden;background-size: 100% 100%">
      <el-row :gutter="10" type="flex"  style="min-height: 80%;top: 10%">
        <el-col :span="5">
          <div style="text-align: center;width: 100%;height: 100%;" >
            <div><span style="font-size: 1.5vh;color: #060606;font-weight: 800">其他行业</span></div>
            <div style="margin-top: 5px;text-align: left;padding-left: 20px;padding-right: 20px"><span style="font-size: 1.2vh;color: #7f7f7f;">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;物联网场景类产品在智慧城市、工业互联网领域有更加广阔的应用，如：环保、发电、交通、市政管理、
              地下管廊等等......
               </span>
            </div>
            <div style="position: absolute;top: 87%;left: 2%;color: #3e077d;cursor: pointer" @click="sceneDetails('others')"><span>更多场景-></span></div>
            <div style="position: absolute;top: 87%;left: 14%;color: #3e077d;cursor: pointer" @click="sceneDetails('architecture')"><span>创建场景-></span></div>

          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/5-1.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">风力发电机组监控场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">风力发电机组运行安全管理，设备健康管理相关数据远程实时...</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/5-2.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">物联网交通信号机</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">物联网化的交通路口管理应用包括红路灯健康管理，传感器...</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/5-3.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">环保污染监测场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">兼容各种环保污染物传感器，支持RS485标准及非标协议...</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/5-4.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">智慧灯杆应用场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">用于普通路灯的智慧化改造，支持各种传感器及智能设备接入</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/5-5.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">地下管廊应用场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">用于地下管廊配电、通道、环境、传感器及其它设备设施...</span></div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="width: 100%;height: 100%;background-color: #eeeeee;cursor: pointer">
            <div style="width: 100%;height: 60%;background-image: url('/static/img/mould/5-6.jpg');background-size: 100% 100%"></div>
            <div style="width: 100%;height: 40%;overflow: hidden;padding-top: 5px;padding-left: 5px">
              <div><span style="color: black;font-size: 1vh;font-weight: 800">锅炉安全应用场景</span></div>
              <div><span style="color: #7c7c7c;font-size: 1vh">锅炉内设备设施，及环境安全运维管理、安全管理的物联网化...</span></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--建筑空间-->
    <el-dialog
      title="办公室场景"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose">
      <div style="width: 100%;height: 500px;margin: 0 auto;">
        <el-row :gutter="1" type="flex" style="min-height: 10%;">
            <el-col :span="20">
              <span style="font-size: 1.2vh">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;独立办公室场景控制程序，管理对象为：窗帘、风机盘管、照明灯具、门禁、电力参数及用电安全监控、室内环境监控。本程序对风机盘管实现全自动群控管理，可对风机盘管进行热力计量，具有缺水保护及温度限制功能，可最大限度减低能耗。用户可通过液晶面板或手机完成本地控制。
               </span>
            </el-col>
            <el-col :span="4">
              <div class="programBt"><el-button  type="primary" size="mini" style="margin-left: 12%"  @click="icuOpen">ICU程序下载</el-button></div>
            </el-col>
          </el-row>
        <el-row :gutter="1" type="flex"  style="min-height: 10%;margin-top: 2%">
            <el-col :span="20">
              <span style="font-size: 1.2vh">&nbsp;&nbsp;&nbsp;&nbsp;本程序用于施工人员现场对物联网设备进行配置和调试，下载此程序文件至SD卡，通过SD卡安装到OP(现场调试终端)，即可进行程序配置与调试，详细步骤参考
               </span>
              <a style="font-size: 1.2vh">OP使用说明</a>
            </el-col>
            <el-col :span="4">
              <div class="programBt"><el-button size="mini"  type="primary" style="margin-left: 12%"  @click="open">&nbsp;OP程序下载&nbsp;</el-button></div>
            </el-col>
          </el-row>
        <el-row :gutter="10"  type="flex"  style="min-height: 35%;margin-top: 2%">
            <el-col :span="24">
              <div style="width: 100%;height: 300px;overflow: auto;padding: 15px 15px">
                <div style="font-size: 1.2vh;"><span>控制对象:</span></div>
                <el-row :gutter="20"  type="flex"  style="min-height: 35%">
                 <el-col :span="4">
                   <div style="width: 100%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/风机盘管.jpg');display: flex;">
                    <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 54%">
                      <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">风机盘管</span>
                    </div>
                   </div>
                 </el-col>
                 <el-col :span="4">
                  <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/灯.jpg');display: flex">
                    <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                      <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">照明</span>
                    </div>
                  </div>
                 </el-col>
                 <el-col :span="4">
                   <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/电控锁.jpg');display: flex">
                     <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                       <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">电控锁</span>
                     </div>
                   </div>
                 </el-col>
                 <el-col :span="4">
                   <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/电动窗帘.jpg');display: flex">
                     <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                       <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">电动窗帘</span>
                     </div>
                   </div>
                 </el-col>
                 <el-col :span="4">
                   <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/电动开窗器.jpg');display: flex">
                     <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                       <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">电动开窗器</span>
                     </div>
                   </div>
                 </el-col>
                  <!--<el-col :span="4">
                    <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/电动开窗器1.jpg')"></div>
                  </el-col>-->
               </el-row>
             <!--   <el-row :gutter="20"  type="flex"  style="min-height: 2%;margin-top: 1%">
                  <el-col :span="4">
                    <div style="width: 100%;height: 100%;text-align: center"><span>风机盘管</span></div>
                  </el-col>
                  <el-col :span="4">
                    <div style="width: 100%;height: 100%;text-align: center"><span>灯光</span></div>
                  </el-col>
                  <el-col :span="4">
                    <div style="width: 100%;height: 100%;text-align: center"><span>电控锁</span></div>
                  </el-col>
                  <el-col :span="4">
                    <div style="width: 100%;height: 100%;text-align: center"><span>电动窗帘</span></div>
                  </el-col>
                  <el-col :span="4">
                    <div style="width: 100%;height: 100%;text-align: center"><span>电动开窗器</span></div>
                  </el-col>
                 &lt;!&ndash; <el-col :span="4">
                    <div style="width: 100%;height: 100%;text-align: center"><span>电动开窗器</span></div>
                  </el-col>&ndash;&gt;
                  &lt;!&ndash;<el-col :span="5">
                    <div style="width: 50%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/灯.jpg')"></div>
                  </el-col>
                  <el-col :span="5">
                    <div style="width: 50%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/阴极锁.jpg')"></div>
                  </el-col>
                  <el-col :span="5">
                    <div style="width: 50%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/电动窗帘.jpg')"></div>
                  </el-col>
                  <el-col :span="5">
                    <div style="width: 50%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/电动开窗器.jpg')"></div>
                  </el-col>&ndash;&gt;
                </el-row>-->
                <div style="font-size: 1.2vh;margin-top: 1%"><span>控制组件:</span></div>
                <el-row :gutter="20"  type="flex"  style="min-height: 35%">
                  <el-col :span="4">
                    <div style="width: 100%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/ICU.jpg');display: flex">
                      <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 54%">
                        <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">物联网控制器</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/起动机.jpg');display: flex">
                      <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                        <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">盘管模块及电动阀</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/空气.jpg');display: flex">
                      <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                        <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">环境传感器</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/门锁.jpg');display: flex">
                      <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                        <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">读卡器</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/显示器.jpg');display: flex">
                      <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                        <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">液晶屏</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/红外线.jpg');display: flex">
                      <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                        <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">照度传感器</span>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
        </el-row>
        <el-row :gutter="30"  type="flex"  style="min-height: 10%;margin-top: 1%">
          <el-col :span="3">
            <div style="width: 90%;height: 5%;font-size: 1vh;cursor: pointer"><span style="color: #0096e6">场景方案下载</span></div>
          </el-col>
          <el-col :span="3">
            <div style="width: 90%;height: 5%;font-size: 1vh;cursor: pointer"><span style="color: #0096e6">安装视频下载</span></div>
          </el-col>
          <el-col :span="3">
            <div style="width: 90%;height: 5%;font-size: 1vh"><span style="color: #0096e6;cursor: pointer">接线图下载</span></div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="initWebSocket">尝试连接</el-button>
        <el-button @click="disconnect">断开连接</el-button>
       </span>
    </el-dialog>
    <!--冷冻站场景-->
    <el-dialog
      title="约克螺杆机组物联网控制网关"
      :visible.sync="yueke"
      width="50%"
      :before-close="handleCloseYueke">
      <div style="width: 100%;height: 500px;margin: 0 auto;">
        <el-row :gutter="1" type="flex" style="min-height: 10%;">
          <el-col :span="20">
              <span style="font-size: 1.2vh">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本程序适用于YK XXXXXXXXXXX系列机组，用于通过现场总线，获取冷机数据并支持总线层冷机群控应用。
               </span>
          </el-col>
          <el-col :span="4">
            <div class="programBt"><el-button  type="primary" size="mini" style="margin-left: 12%"  @click="icuOpen">ICU程序下载</el-button></div>
          </el-col>
        </el-row>
          <!--<el-row :gutter="1" type="flex"  style="min-height: 10%;margin-top: 2%">
          <el-col :span="20">
              <span style="font-size: 1.2vh">&nbsp;&nbsp;&nbsp;&nbsp;本程序用于施工人员现场对物联网设备进行配置和调试，下载此程序文件至SD卡，通过SD卡安装到OP(现场调试终端)，即可进行程序配置与调试，详细步骤参考
               </span>
            <a style="font-size: 1.2vh">OP使用说明</a>
          </el-col>
          <el-col :span="4">
            <div class="programBt"><el-button size="mini"  type="primary" style="margin-left: 12%"  @click="open">&nbsp;OP程序下载&nbsp;</el-button></div>
          </el-col>
        </el-row>-->
        <el-row :gutter="10"  type="flex"  style="min-height: 50%;margin-top: 2%">
          <el-col :span="24">
            <div style="width: 100%;height: 400px;overflow: auto;padding: 15px 15px">
              <div style="font-size: 1.2vh;"><span>冷水机组通讯协议:</span></div>
              <!--<el-row :gutter="20"  type="flex"  style="min-height: 35%">
                <el-col :span="4">
                  <div style="width: 100%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/风机盘管.jpg');display: flex;">
                    <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 54%">
                      <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">风机盘管</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/灯.jpg');display: flex">
                    <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                      <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">照明</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/电控锁.jpg');display: flex">
                    <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                      <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">电控锁</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/电动窗帘.jpg');display: flex">
                    <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                      <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">电动窗帘</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/电动开窗器.jpg');display: flex">
                    <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                      <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">电动开窗器</span>
                    </div>
                  </div>
                </el-col>
                &lt;!&ndash;<el-col :span="4">
                  <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/电动开窗器1.jpg')"></div>
                </el-col>&ndash;&gt;
              </el-row>
              <div style="font-size: 1.2vh;margin-top: 1%"><span>控制组件:</span></div>
              <el-row :gutter="20"  type="flex"  style="min-height: 35%">
                <el-col :span="4">
                  <div style="width: 100%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/ICU.jpg');display: flex">
                    <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 54%">
                      <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">物联网控制器</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/起动机.jpg');display: flex">
                    <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                      <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">盘管模块及电动阀</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/空气.jpg');display: flex">
                    <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                      <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">环境传感器</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/门锁.jpg');display: flex">
                    <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                      <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">读卡器</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/显示器.jpg');display: flex">
                    <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                      <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">液晶屏</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div style="width: 98%;height: 100%;background-size: 100% 100%;background-image: url('/static/img/mould/红外线.jpg');display: flex">
                    <div style="width: 100%;height: 24%;background-color: rgba(82,73,73,0.62);display: flex;align-items: center;justify-content: center;margin-top: 55%">
                      <span style="color: rgba(254,254,254,0.9);font-size: 1.2vh">照度传感器</span>
                    </div>
                  </div>
                </el-col>
              </el-row>-->
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="30"  type="flex"  style="min-height: 10%;margin-top: 1%">
          <el-col :span="5">
            <div style="width: 90%;height: 5%;font-size: 1vh;cursor: pointer" @click="openPdf"><span style="color: #0096e6">YK Optiview (Rev K_03)</span></div>
          </el-col>
          <el-col :span="3">
            <div style="width: 90%;height: 5%;font-size: 1vh;cursor: pointer" @click="openExcel"><span style="color: #0096e6">冷机数据表</span></div>
          </el-col>
          <el-col :span="3">
            <div style="width: 90%;height: 5%;font-size: 1vh"><span style="color: #0096e6;cursor: pointer">接线图下载</span></div>
          </el-col>
          <el-col :span="3">
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
       </span>
    </el-dialog>
    <!--进度条-->
    <div class="prostats">
      <el-dialog
      title=""
      :visible.sync="jindu"
      width="20%"
      :before-close="handleCloseJindu">
      <div style="width: 100%;height: 200px;margin: 0 auto;">
        <div class="progress" style="margin-left: 30%;margin-top: 13%">
           <el-progress type="circle" :percentage="provalue" :color="colors"></el-progress>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
       </span>
    </el-dialog>
    </div>
  </div>
</template>

<script>
  import echarts from 'echarts'
  import SockJS from  'sockjs-client';
  import Stomp from 'stompjs';
  import { mapState, mapMutations, mapActions } from 'vuex'
  import service from '../../service/leftService.js'
  export default {
      name: "",
      components: {

      },
      data () {
        return {
          prostatus:'',
          provalue:0,
          jindu:false,
          yueke:false,
          dialogVisible:false,
          vedShow:false,
          websock:null,
          stompClient:'',
          timer:'',
          timernum:null,
          colors: [
            {color: '#f56c6c', percentage: 20},
            {color: '#e6a23c', percentage: 40},
            {color: '#5cb87a', percentage: 60},
            {color: '#1989fa', percentage: 80},
            {color: '#6f7ad3', percentage: 100}
          ]
        }
      },
      computed: {
        ...mapState({
          visible: 'authorityShow',
          objectData: 'objectInfo',
          nodeData: 'nodeTree'
        })
      },
      destroyed () {
        //页面销毁时关闭ws连接
        this.disconnect();
        clearInterval(this.timer);
        clearInterval(this.timernum);
      },
      beforeDestroy() {
        // 页面离开时断开连接,清除定时器
        this.disconnect();
        clearInterval(this.timer);
        clearInterval(this.timernum);
      },
      mounted () {
      },
      methods: {
        // 进度添加
        speedTime(){
          let _this = this
          _this.timernum = setInterval(function () {
            let num = Math.ceil(Math.random()*5);
            if(_this.provalue >= 80){
              _this.provalue = 85
              clearInterval(_this.timernum);
            }else{
              _this.provalue += num
            }
          },600)
        },
        handleCloseJindu(){
          this.jindu = false
        },
        programDetails(){
          this.dialogVisible = true
        },
        handleClose(done) {
          /*this.$confirm('确认关闭？')
            .then(_ => {
              done();
            })
            .catch(_ => {});*/
          done();
        },
        handleCloseYueke(done) {
          /*this.$confirm('确认关闭？')
            .then(_ => {
              done();
            })
            .catch(_ => {});*/
          done();
        },
        vedShowCli(){
          this.vedShow = true
        },
        closeVedShow(){
          this.vedShow = false
        },
        sceneDetails(title){
          this.$router.push({name: 'orderDetailsAll',query: {tit:title}})
        },
        creationScence(){
          this.$router.push({name: 'sceneCreation'})
        },
        // OP程序下载
        open() {
          this.$confirm('是否确认下载该程序?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const link = document.createElement('a')
            link.href = '/static/word/peizhi.tft'
            link.setAttribute('download','peizhi.tft')
            document.body.appendChild(link)
            link.click()
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消下载'
            });
          });
        },
        // ICU程序下载
        icuOpen(){
          let _this = this
          this.$confirm('是否确认下载该程序到设备?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.jindu = true;
            this.speedTime()
            service.orderDown(this.objectData.id).then(res=>{
           //   _this.provalue = 0
              this.$message({
                type: 'success',
                message: '下载成功'
              });
             // this.jindu = false
            }).catch(err=>{
              clearInterval(this.timernum);
           //   _this.provalue = 0
            //  this.jindu = false
              this.$message({
                type: 'error',
                message: '下载失败'
              });
            })
          }).catch(() => {
            _this.provalue = 0
            this.$message({
              type: 'info',
              message: '已取消下载'
            });
          });
        },
        // PDF下载
        openPdf() {
          this.$confirm('是否确认下载PDF?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const link = document.createElement('a')
            link.href = '/static/word/YK Optiview (Rev K_03).pdf'
            link.setAttribute('download','YK Optiview (Rev K_03).pdf')
            document.body.appendChild(link)
            link.click()
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消下载'
            });
          });
        },
        // Excel文件下载
        openExcel() {
          this.$confirm('是否确认下载该Excel?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const link = document.createElement('a')
            link.href = '/static/word/冷机.xlsx'
            link.setAttribute('download','冷机.xlsx')
            document.body.appendChild(link)
            link.click()
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消下载'
            });
          });
        },
        // 连接机制
        initWebSocket() {
          this.connection();
          let that= this;
          // 断开重连机制,尝试发送消息,捕获异常发生时重连
          this.timer = setInterval(() => {
            try {
              that.stompClient.send("test");
            } catch (err) {
              console.log("断线了: " + err);
              that.connection();
            }
          }, 5000);
        },
        // 与后台进行通讯
        connection() {
          // 建立连接对象
          let socket = new SockJS('http://192.168.10.119:9001/websocket');
          // 获取STOMP子协议的客户端对象
          this.stompClient = Stomp.over(socket);
          // 定义客户端的认证信息,按需求配置
          let tokend = localStorage.getItem('Authorization')
          let userId = localStorage.getItem('userId')
          let headers = {
            Authorization:tokend
          }
          // 向服务器发起websocket连接
          this.stompClient.connect(headers,() => {
            this.stompClient.subscribe('/topic/public', (msg) => {// 订阅服务端提供的某个topic
              console.log('广播成功')
              console.log("服务端发送给我们的信息"+ msg.body);  // msg.body存放的是服务端发送给我们的信息
            });

            this.stompClient.subscribe("/user/8/queue/notifications", (res) => {// 订阅服务端提供的某个topic
              console.log('私立广播成功')
              console.log("私立服务端发送给我们的信息"+ res.body);  // msg.body存放的是服务端发送给我们的信息
            });

            this.stompClient.send("/app/addUser",
              headers,
              JSON.stringify({sender: userId, token: tokend}),
            )   //用户加入接口
          }, (err) => {
            // 连接发生错误时的处理函数
            console.log('失败')
            console.log(err);
          });
         /* // 聊天测试
          var stomp = Stomp.over(sock);
          stomp.connect('guest','guest',function (frame) {
            stomp.subscribe("/user/queue/notifications", handleNotification);
          });
          function handleNotification(message) {
            $("#output").append("<b>Received： "+message.body+"</b><br/>")
          }
          function sendSpittle(text) {
            stomp.send("/chat", {}, text);
          }*/

        },
        // 断开连接
        disconnect() {
          if (this.stompClient) {
            this.stompClient.disconnect();
          }
        },
      },
    }
</script>

<style scoped>
  .program>>> .el-dialog__body{
    background-color: white;
    padding: 15px 15px;
  }
  .program>>> .el-dialog__header{
    background-color: #e0e0e0;
    padding: 10px 10px;
    height: 35px;
  }
  .program>>>.el-dialog__title{
    font-size: 1.5vh;
    font-weight: 800;
    line-height: 20px;
  }
  .program>>>.el-dialog__headerbtn{
    top: 10px;
  }
  .programBt>>>.el-button{
    width: 80%;
    height: 100%;
    background-color: rgba(48, 160, 245, 0.84);
    color: #f4f4f4;
  }
  .program>>>.el-button{
    background-color: rgba(48, 160, 245, 0.84);
    color: #f4f4f4;
  }
  .prostats>>>.el-dialog__header{
    display: none;
  }
  .prostats>>>.el-dialog__footer{
    display: none;
  }
  .prostats>>>.el-dialog__body{
    background-color: transparent;
  }
  .prostats>>>.el-dialog{
    background: transparent;
    top: 8%;
  }
  .progress>>>.el-progress__text{
    color: #2ebaff;
  }
</style>



// WEBPACK FOOTER //
// src/components/orderSelect/orderSelect.vue